import { Grid2 as Grid } from "@mui/material";
import { useTranslate } from "@refinedev/core";

import { Form } from "@shared/components";

export function LevelForm() {
  const translate = useTranslate();

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12 }}>
        <Form.Input
          name="name"
          label={translate("level_admin.fields.name")}
          required
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.Input
          name="rank"
          label={translate("level_admin.fields.rank")}
          required
          type="number"
        />
      </Grid>
    </Grid>
  )
}
